import * as React from "react";
import {
  highlightPlugin,
  HighlightArea,
  MessageIcon,
  RenderHighlightContentProps,
  RenderHighlightsProps,
  RenderHighlightTargetProps,
} from "@react-pdf-viewer/highlight";
import {
  pageNavigationPlugin,
  RenderGoToPageProps,
} from "@react-pdf-viewer/page-navigation";
import {
  Button,
  Icon,
  MinimalButton,
  Position,
  PrimaryButton,
  Tooltip,
  Viewer,
  Worker,
  SpecialZoomLevel
} from "@react-pdf-viewer/core";

import disableScrollPlugin from "./disableScrollPlugin";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { pdfjs } from "react-pdf";
import { useRef } from "react";

const LOCAL_STORAGE_KEY = "pdf_highlights";

const RenderHighlightsExample = ({ fileUrl, result, phoneNumber }) => {
  const [message, setMessage] = React.useState("");
  const [notes, setNotes] = React.useState([]);
  const pdfRef = React.useRef(null);

  const pageNavigationPluginInstance = pageNavigationPlugin();
  const disableScrollPluginInstance = disableScrollPlugin();

  const { GoToNextPage, GoToPreviousPage, jumpToPage, CurrentPageLabel } =
    pageNavigationPluginInstance;

    const STORAGE_KEY = `pdf_highlights_${result?.id}`;

    // Load saved highlights when the component mounts or PDF ID changes
    React.useEffect(() => {
        const savedNotes = localStorage.getItem(STORAGE_KEY);
        if (savedNotes) {
            setNotes(JSON.parse(savedNotes));
        } else {
            setNotes([]); // Clear notes when switching PDFs
        }
    }, [result]);

    // Save highlights to localStorage when notes change
    React.useEffect(() => {
        if (notes.length > 0) {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(notes));
        }
    }, [notes]);


    const renderHighlightTarget = (props) => {
      const addNote = () => {
          const newNote = {
              id: new Date().getTime(), // Unique ID
              content: "بدون عنوان", // Default content
              highlightAreas: props.highlightAreas,
              quote: props.selectedText,
          };
  
          setNotes((prevNotes) => {
              const updatedNotes = [...prevNotes, newNote];
              localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedNotes)); // Save immediately
              return updatedNotes;
          });
  
          props.cancel(); // Close the highlight selection
      };
  
      return (
          <div
              style={{
                  background: "#eee",
                  display: "flex",
                  position: "absolute",
                  left: `${props.selectionRegion.left}%`,
                  top: `${props.selectionRegion.top + props.selectionRegion.height}%`,
                  transform: "translate(0, 8px)",
                  zIndex: 1,
              }}
          >
              <Tooltip
                  position={Position.TopCenter}
                  target={<Button onClick={addNote}>هایلایت</Button>}
                  content={() => null}
                  offset={{ left: 0, top: -8 }}
              />
          </div>
      );
  };

  // const renderHighlightContent = (props) => {
  //   const addNote = () => {
  //       if (message !== '') {
  //           const newNote = {
  //               id: new Date().getTime(), // Unique ID
  //               content: message,
  //               highlightAreas: props.highlightAreas,
  //               quote: props.selectedText,
  //           };

  //           setNotes((prevNotes) => {
  //               const updatedNotes = [...prevNotes, newNote];
  //               localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedNotes)); // Save immediately
  //               return updatedNotes;
  //           });

  //           setMessage('');
  //           props.cancel();
  //       }
  //   };

  //   return (
  //     <div
  //       style={{
  //         background: "#fff",
  //         border: "1px solid rgba(0, 0, 0, .3)",
  //         borderRadius: "2px",
  //         padding: "8px",
  //         position: "absolute",
  //         left: `${props.selectionRegion.left}%`,
  //         top: `${props.selectionRegion.top + props.selectionRegion.height}%`,
  //         zIndex: 1,
  //       }}
  //     >
  //       <div>
  //         <textarea
  //           rows={3}
  //           style={{
  //             border: "1px solid rgba(0, 0, 0, .3)",
  //           }}
  //           value={message}
  //           placeholder="عنوان هایلایت"
  //           onChange={(e) => setMessage(e.target.value)}
  //         ></textarea>
  //       </div>
  //       <div
  //         style={{
  //           display: "flex",
  //           marginTop: "8px",
  //         }}
  //       >
  //         <div style={{ marginRight: "8px" }}>
  //           <PrimaryButton onClick={addNote}>اضافه کردن</PrimaryButton>
  //         </div>
  //         <Button onClick={props.cancel}>انصراف</Button>
  //       </div>
  //     </div>
  //   );
  // };

  const renderHighlights = (props) => (
    <div>
      {notes.map((note) => (
        <React.Fragment key={note.id}>
          {note.highlightAreas
            .filter((area) => area.pageIndex === props.pageIndex)
            .map((area, idx) => (
              <div
                key={idx}
                style={Object.assign(
                  {},
                  {
                    background: "cyan",
                    opacity: 0.4,
                  },
                  props.getCssProperties(area, props.rotation)
                )}
              />
            ))}
        </React.Fragment>
      ))}
    </div>
  );

  // Pass saved highlights to the highlight plugin
  const highlightPluginInstance = highlightPlugin({
    renderHighlightTarget,
    // renderHighlightContent,
    renderHighlights,
  });
  
  return (
    <>
    <div
              className=" controls"
              style={{ display: "flex", justifyContent: "space-around" }}
              onContextMenu={(e) => e.preventDefault()}
            >
              <GoToNextPage>
                {(props) => (
                  <Tooltip
                    position={Position.BottomCenter}
                    target={
                      <button
                        className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
                        style={{ height: "40px" }}
                        onClick={props.onClick}
                      >
                        بعدی
                      </button>
                    }
                    content={() => "Next page"}
                    offset={{ left: 0, top: 8 }}
                  />
                )}
              </GoToNextPage>
              <CurrentPageLabel>
                {(props) => (
                  <>
                    <span>
                      صفحه {props.currentPage + 1} از {props.numberOfPages}
                    </span>
                  </>
                )}
              </CurrentPageLabel>
              {/* <CurrentPageLabel>
                {(props) => (
                  <>
                    <span>صفحه</span>

                    <select
                      name="pages"
                      id="pages"
                      value={pageNumber}
                      onChange={(e) => {
                        setPageNumber(+e.target.value);
                        jumpToPage(+e.target.value);
                      }}
                      style={{ width: 100, margin: "0px 10px" }}
                    >
                      {props.numberOfPages &&
                        [...Array(props.numberOfPages).keys()].map((i) => (
                          <option key={i} value={i}>
                            {i}
                          </option>
                        ))}
                    </select>
                  </>
                )}
              </CurrentPageLabel> */}
              <GoToPreviousPage>
                {(props) => (
                  <Tooltip
                    position={Position.BottomCenter}
                    target={
                      <button
                        className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
                        style={{ height: "40px" }}
                        onClick={props.onClick}
                        // disabled={pageNumber === 1}
                      >
                        قبلی
                      </button>
                    }
                    content={() => "Previous page"}
                    offset={{ left: 0, top: 8 }}
                  />
                )}
              </GoToPreviousPage>
            </div>
    <Worker
      workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`}
    >
      <div
        ref={pdfRef}
        className={
          result?.isOfoghi !== undefined &&
          result?.isOfoghi !== null &&
          result.isOfoghi === true
            ? "rpv-core__viewer isOfoghi"
            : "rpv-core__viewer"
        }
        style={{
          height: "90%",
          width: "85%",
          position: "relative",
          display: "flex",
          justifyContent: "center",
          marginBottom: 18,
          margin: "0 auto",
        }}
      >
        <div className="water-mark-phoneNum-pdf">{phoneNumber}</div>
        <div
          style={{
            position: "absolute",
            right: 0,
            top: "50%",
            transform: "translate(-24px, -50%)",
            zIndex: 1,
          }}
        >
          <GoToNextPage>
            {(props) => (
              <Tooltip
                position={Position.BottomCenter}
                target={
                  <MinimalButton onClick={props.onClick}>
                    <Icon size={16}>
                      <path d="M5.651,23.5,18.227,12.374a.5.5,0,0,0,0-.748L5.651.5" />
                    </Icon>
                  </MinimalButton>
                }
                content={() => "Next page"}
                offset={{ left: 0, top: 8 }}
              />
            )}
          </GoToNextPage>
        </div>
        <div
          style={{
            left: 0,
            position: "absolute",
            top: "50%",
            transform: "translate(24px, -50%)",
            zIndex: 1,
          }}
        >
          <GoToPreviousPage>
            {(props) => (
              <Tooltip
                position={Position.BottomCenter}
                target={
                  <MinimalButton onClick={props.onClick}>
                    <Icon size={16}>
                      <path d="M18.4.5,5.825,11.626a.5.5,0,0,0,0,.748L18.4,23.5" />
                    </Icon>
                  </MinimalButton>
                }
                content={() => "Previous page"}
                offset={{ left: 0, top: 8 }}
              />
            )}
          </GoToPreviousPage>
        </div>
        {fileUrl ? (
          <Viewer
            fileUrl={fileUrl}
            defaultScale={SpecialZoomLevel.PageFit}
            plugins={[
              highlightPluginInstance,
              disableScrollPluginInstance,
              pageNavigationPluginInstance,
            ]}
          />
        ) : (
          <p>Loading PDF...</p>
        )}
      </div>
    </Worker>
    <div
              className="controls ctrl2"
              style={{ display: "flex", justifyContent: "space-around" }}
              onContextMenu={(e) => e.preventDefault()}
            >
              <GoToNextPage>
                {(props) => (
                  <Tooltip
                    position={Position.BottomCenter}
                    target={
                      <button
                        className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
                        style={{ height: "40px" }}
                        onClick={props.onClick}
                      >
                        بعدی
                      </button>
                    }
                    content={() => "Next page"}
                    offset={{ left: 0, top: 8 }}
                  />
                )}
              </GoToNextPage>
              <GoToPreviousPage>
                {(props) => (
                  <Tooltip
                    position={Position.BottomCenter}
                    target={
                      <button
                        className="btn btn-sm btn-light d-flex align-items-center justify-content-center"
                        style={{ height: "40px" }}
                        onClick={props.onClick}
                        // disabled={pageNumber === 1}
                      >
                        قبلی
                      </button>
                    }
                    content={() => "Previous page"}
                    offset={{ left: 0, top: 8 }}
                  />
                )}
              </GoToPreviousPage>
            </div>
    </>
  );
};

export default RenderHighlightsExample;
